import { render } from "./ContentBuilderComponent.vue?vue&type=template&id=1db146cc"
import script from "./ContentBuilderComponent.vue?vue&type=script&lang=js"
export * from "./ContentBuilderComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__